const NRISection = () => {
  return (
    <section class="about about--style1 bg-color xts-section">
        <div class="container">
            <div class="about__wrapper">
                <div class="row gx-5 gy-4 gy-sm-0 align-items-center">
                    <div class="col-lg-6">
                        <div class="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                            <div class="about__thumb-inner">
                                <div class="about__thumb-image floating-content">
                                    <img class="dark" src="assets/images/new/nri.webp" alt="Retail Investor"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="about__content" data-aos="fade-left" data-aos-duration="800">
                            <div class="about__content-inner">
                                  <h2 class="meet-oppurtanity">NRI & <span class="style2">FPI</span></h2>
                                <p>
                          Simplified account setup, access to Indian equities and derivatives, and streamlined compliance make investing easy for NRIs and FPIs—with support for global transactions                                 </p>
                            </div>
                        </div>
                    </div>
                   {/* <div className="col-lg-12 mt-30">
                      <div className="benefits-section" data-aos="fade-up" data-aos-duration="800">
                        <div className="benefits-inner">
                          <h3 className="benefits-title">Key Characteristics</h3>

                          <div className="benefits-list">
                            <div className="benefit-item" data-aos="fade-left" data-aos-duration="800">
                              <div className="benefit-icon">
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <div className="benefit-content">
                                <h5 className="benefit-heading">Individual Investors</h5>
                                <p className="benefit-text">
                                  Retail investors are individuals, not organizations.
                                </p>
                              </div>
                            </div>

                            <div className="benefit-item" data-aos="fade-left" data-aos-duration="800">
                              <div className="benefit-icon">
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <div className="benefit-content">
                                <h5 className="benefit-heading">Personal Accounts</h5>
                                <p className="benefit-text">
                                  They invest their own money for personal financial goals.
                                </p>
                              </div>
                            </div>

                            <div className="benefit-item" data-aos="fade-left" data-aos-duration="800">
                              <div className="benefit-icon">
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <div className="benefit-content">
                                <h5 className="benefit-heading">Smaller Capital</h5>
                                <p className="benefit-text">
                                  Compared to institutional investors, they manage smaller amounts of capital.
                                </p>
                              </div>
                            </div>

                            <div className="benefit-item" data-aos="fade-left" data-aos-duration="800">
                              <div className="benefit-icon">
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <div className="benefit-content">
                                <h5 className="benefit-heading">Accessibility</h5>
                                <p className="benefit-text">
                                  They use online trading platforms and apps to participate in the market.
                                </p>
                              </div>
                            </div>

                            <div className="benefit-item" data-aos="fade-left" data-aos-duration="800">
                              <div className="benefit-icon">
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <div className="benefit-content">
                                <h5 className="benefit-heading">Broad Range of Knowledge</h5>
                                <p className="benefit-text">
                                  This group includes both novice investors and experienced traders.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                   <div class="col-lg-12 mt-30">
                      <div class="about__content">
                          <div class="about__content-inner">
                              <h3
                                className="text-center"
                                data-aos="fade-right"
                                data-aos-duration="500"
                              >
                                NRI Investment Methods
                              </h3>

                              <div className="platform-features">
                                <div
                                  className="feature-card"
                                  data-aos="fade-left"
                                  data-aos-duration="500"
                                >
                                  <div className="feature-icon">
                                    <i className="fas fa-university"></i>
                                  </div>
                                  <div className="feature-title">Non-PIS accounts</div>
                                  <div className="feature-desc">
                                    NRIs can use Non-Portfolio Investment Scheme accounts to invest in
                                    Indian stocks, mutual funds, and ETFs.
                                  </div>
                                </div>

                                <div
                                  className="feature-card"
                                  data-aos="fade-down"
                                  data-aos-duration="500"
                                >
                                  <div className="feature-icon">
                                    <i className="fas fa-hand-holding-usd"></i>
                                  </div>
                                  <div className="feature-title">Direct Investment</div>
                                  <div className="feature-desc">
                                    NRIs can also make direct investments through designated NRE
                                    (Non-Resident External) and NRO (Non-Resident Ordinary) accounts.
                                  </div>
                                </div>

                                <div
                                  className="feature-card"
                                  data-aos="fade-right"
                                  data-aos-duration="500"
                                >
                                  <div className="feature-icon">
                                    <i className="fas fa-ban"></i>
                                  </div>
                                  <div className="feature-title">Restrictions</div>
                                  <div className="feature-desc">
                                    An individual NRI cannot directly seek registration as an FPI.
                                  </div>
                                </div>

                                <div class="info-box mt-4">
                                  <h3 class="mb-3" data-aos="fade-right" data-aos-duration="800"> 
                                      NRI Contribution to FPIs
                                  </h3>
                                  <p data-aos="fade-left" data-aos-duration="500">
                                      NRIs can contribute to the corpus of an FPI with certain limits: a single NRI's contribution is capped at 25%, and the total aggregate contribution from all NRIs, Overseas Citizens of India (OCIs), and Resident Indians (RIs) cannot exceed 50% of the FPI's corpus. However, in International Financial Services Centres (IFSCs), regulations have been relaxed, allowing up to 100% aggregate contribution by NRIs/OCIs/RIs.
                                  </p>
                              </div>
                              
                              <h3 class="mt-4 mb-3" data-aos="fade-right" data-aos-duration="800">
                                  FPI Overview
                              </h3>
                              <p class="mb-2" data-aos="fade-left" data-aos-duration="500">
                                  <b>Who they are:</b> Foreign Portfolio Investors are typically foreign entities like institutional investors (mutual funds, asset management companies), banks, or other regulated bodies investing in India.
                              </p>
                              <p class="mb-2" data-aos="fade-left" data-aos-duration="500">
                                  <b>Investment Approach:</b> FPIs invest in Indian securities without seeking to control or manage the companies they invest in.
                              </p>
                            </div>
                              
                              <table class="comparison-table" data-aos="fade-up" data-aos-duration="800">
                                  <thead>
                                      <tr>
                                          <th>Aspect</th>
                                          <th>NRI</th>
                                          <th>FPI</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td><b>Definition</b></td>
                                          <td>Individual of Indian origin residing abroad</td>
                                          <td>Foreign entity investing in Indian securities</td>
                                      </tr>
                                      <tr>
                                          <td><b>Investment Approach</b></td>
                                          <td>Personal investment</td>
                                          <td>Portfolio investment without control</td>
                                      </tr>
                                      <tr>
                                          <td><b>Registration</b></td>
                                          <td>As an individual</td>
                                          <td>As a foreign entity</td>
                                      </tr>
                                      <tr>
                                          <td><b>Contribution Limits</b></td>
                                          <td>Subject to individual investment limits</td>
                                          <td>Subject to FPI regulations and limits</td>
                                      </tr>
                                      <tr>
                                          <td><b>Accounts Used</b></td>
                                          <td>NRE, NRO, Non-PIS accounts</td>
                                          <td>Registered FPI accounts</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>

                </div>
            </div>
        </div>
    </section>
  );
};

export default NRISection;